import { useContext } from 'react'

import { MediaSelectContext } from '../contexts/MediaSelectContext'

const useMediaSelectContext = () => {
  const context = useContext(MediaSelectContext)

  if (!context) {
    throw new Error('useMediaSelectContext must be used within a MediaSelectProvider')
  }

  return context
}

export default useMediaSelectContext
